import React from 'react'
import { Grid, Typography, Box, Paper, useTheme } from '@mui/material'
import { Icon } from '@iconify/react'

export default function Component() {
  const theme = useTheme()

  return (
    <Paper 
      elevation={3}
      sx={{
        bgcolor: '#F0891F',
        color: 'white',
        mt: 3,
        py: 3,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: `linear-gradient(90deg, ${theme.palette.secondary.main}, #163E6A)`,
        },
      }}
    >
      <Box 
        maxWidth="lg" 
        mx="auto"
        sx={{
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '-80px',
            right: '-80px',
            width: '200px',
            height: '200px',
            background: `radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%)`,
            zIndex: 0,
          },
        }}
      >
        <Grid container spacing={8} px={4}>
          {[
            [
              { 
                icon: 'streamline:information-desk', 
                title: 'Mesa de entrada Municipalidad', 
                number: '(03525) 642892',
                acceptsCallAndWhatsapp: true
              },
              { 
                icon: 'mdi:phone', 
                title: 'Dirección de turismo y cultura', 
                number: '(03525)  491456 - int. 108',
                whatsapp: '(03525) 601475'
              },
            ],
            [
              { icon: 'mdi:hospital-box', title: 'Centro de salud', whatsapp: '(03525) 545050'  },
              { icon: 'mdi:fire-truck', title: 'Bomberos', number: '(03525) 491389' },
            ],
            [
              { icon: 'mdi:police-badge', title: 'Policía', number: '(03525) 491881 / 101' },
              { icon: 'mdi:bus', title: 'Servicio urbano de pasajeros', number: '(03525) 434290' },
            ],
          ].map((column, columnIndex) => (
            <Grid item xs={12} sm={4} key={columnIndex}>
              <Box component="ul" sx={{ listStyle: 'none', padding: 0, '& li': { mb: 4 } }}>
                {column.map((item, itemIndex) => (
                  <Box 
                    component="li" 
                    key={itemIndex}
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      transition: 'transform 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-5px)',
                      },
                    }}
                  >
                    <Icon 
                      icon={item.icon} 
                      style={{ 
                        marginRight: '16px',
                        fontSize: '2.5em',
                        color: '#163E6A',
                      }} 
                    />
                    <Box>
                      <Typography 
                        variant="subtitle1" 
                        sx={{ 
                          fontWeight: 'bold',
                          color: 'white',
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Typography 
                        variant="body2"
                        component="span"
                        sx={{
                          color: 'white',
                          opacity: 0.8,
                          transition: 'opacity 0.3s ease',
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          gap: 0.5,
                          '&:hover': {
                            opacity: 1,
                          },
                        }}
                      >
                        {item.acceptsCallAndWhatsapp ? (
                          <>
                            <Box
                              component="a"
                              href={`tel:${item.number.replace(/\D/g, '')}`}
                              title="Llamar"
                              sx={{
                                display: 'inline-flex',
                                color: 'inherit',
                                '&:hover': { opacity: 1 },
                              }}
                            >
                              <Icon icon="mdi:phone" style={{ fontSize: '1.1em', marginRight: 2 }} />
                            </Box>
                            <Box
                              component="a"
                              href={`https://wa.me/549${item.number.replace(/\D/g, '').replace(/^0/, '')}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              title="WhatsApp"
                              sx={{
                                display: 'inline-flex',
                                color: 'inherit',
                                '&:hover': { opacity: 1 },
                              }}
                            >
                              <Icon icon="ic:round-whatsapp" style={{ fontSize: '1.1em', marginRight: 6 }} />
                            </Box>
                            {item.number}
                          </>
                        ) : (
                          item.number
                        )}
                      </Typography>
                      {item.note && (
                        <Typography 
                          variant="body2"
                          sx={{
                            color: 'white',
                            opacity: 0.9,
                            fontStyle: 'italic',
                            mt: 0.5
                          }}
                        >
                          {item.note}
                        </Typography>
                      )}
                      {item.whatsapp && (
                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                          <Icon 
                            icon="ic:round-whatsapp" 
                            style={{ 
                              marginRight: '8px',
                              fontSize: '1.2em',
                            }} 
                          />
                          <Typography 
                            variant="body2"
                            sx={{
                              color: 'white',
                              opacity: 0.8,
                              transition: 'opacity 0.3s ease',
                              '&:hover': {
                                opacity: 1,
                              },
                            }}
                          >
                            {item.whatsapp}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  )
}